buyBonusButton = {};

buyBonusButton.create = function () {
  var button = new PIXI.Container();

  InputHelpers.addGenerics(button);
  InputHelpers.addAutoplayFlag(button);
  InputHelpers.addCanSpinFlag(button);
  InputHelpers.addInfoPlatformEnabledFlag(button);

  button._potBonusActive = false;

  button._flags.credit = {
    balance: 0,
  };

  button.setupResources = function () {
    let self = this;
    messageBus.subscribe("spinner:GameConfigEvent", function () {
      self.onLayoutComplete();
    });

    messageBus.subscribe("game:sideMenuOpen", button.sideMenuOpenMsg.bind(button));
    messageBus.subscribe("game:sideMenuClosed", button.sideMenuClosedMsg.bind(button));
    messageBus.subscribe("common:BalanceEvent", button.onCreditChanged.bind(button));
    messageBus.subscribe("spinner:GameConfigEvent", button.onGameConfig.bind(button));
    messageBus.subscribe("stake:stakeChanged", button.onStakeChanged.bind(button));
    messageBus.subscribe("common:PromotionStarted", button.promotionStarted.bind(button));
    messageBus.subscribe("common:PromotionEnded", button.promotionEnded.bind(button));
  };

  button.onLayoutComplete = function () {
    button.animParent = resourceManager.get("buttonContainer:buttonBar:buyBonusButton:button");

    button.idleAnim = resourceManager.createObject("movie", "buyBonusIdle", button.animParent, {
      definition: "buyBonusIdle",
      anchor: 0.5,
    });
    button.idleAnim.loop = false;
    button.idleAnim.gotoAndStop(0);

    timerManager.addTimeout(5000, () => {
      button.playIdleAnim();
    });
  };

  button.playIdleAnim = function () {
    if (gameController.idle) {
      button.idleAnim.gotoAndPlay(0);
    }

    timerManager.addTimeout(5000, () => {
      button.playIdleAnim();
    });
  };

  button.canEnable = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    const { BONUS_BUY_LOW, BONUS_BUY_MED, BONUS_BUY_HIGH } = this.gameConfig.data.slotConfig.gameModes;

    let validStake = false;
    if (
      BONUS_BUY_LOW !== undefined &&
      BONUS_BUY_MED !== undefined &&
      BONUS_BUY_HIGH !== undefined &&
      BONUS_BUY_LOW.coinSizes.length > 0 &&
      BONUS_BUY_MED.coinSizes.length > 0 &&
      BONUS_BUY_HIGH.coinSizes.length > 0
    ) {
      validStake = true;
    }

    var canEnable =
      this._flags.canSpin &&
      !this._flags.autoplayStarted &&
      !this._flags.modal.active &&
      !button._sideMenuOpen &&
      validStake &&
      !button.isPromotion;

    resourceManager.get(this.name + ":button").alpha = canEnable ? 1 : 0.5;

    return canEnable;
  };

  button.canShow = function () {
    if (checkForUndefined(this.gameConfig)) return false;

    if (gameController.inFreeSpins) {
      return;
    }

    const { BONUS_BUY_LOW, BONUS_BUY_MED, BONUS_BUY_HIGH } = this.gameConfig.data.slotConfig.gameModes;

    let allowBonusBuy = gdk.getConfigValue("AllowBuyBonus");

    return (
      allowBonusBuy !== false &&
      BONUS_BUY_LOW !== undefined &&
      BONUS_BUY_MED !== undefined &&
      BONUS_BUY_HIGH !== undefined &&
      BONUS_BUY_LOW.coinSizes.length > 0 &&
      BONUS_BUY_MED.coinSizes.length > 0 &&
      BONUS_BUY_HIGH.coinSizes.length > 0 &&
      gdk.getRegulatedMarket() !== "UK" &&
      !button._potBonusActive
    );
  };

  button.onPressedCallback = function () {
    // disable lucky bet button
    buyBonusPopup.show(function () {});
    resourceManager.get("buttonContainer:buttonBar:luckyBetToggleButton").enterBuyABonus();

    if (button.soundName !== "") button.playSound();
  };

  button.onGameConfig = function (event) {
    this.gameConfig = event;
  };

  button.onCreditChanged = function (creditTask) {
    this._flags.credit.balance = creditTask.data.balance;
  };

  button.onStakeChanged = function (stake) {
    this._flags.stake = stake;
  };

  button.promotionStarted = function () {
    button.isPromotion = true;
  };

  button.promotionEnded = function () {
    button.isPromotion = false;
  };

  button.sideMenuOpenMsg = function () {
    button._sideMenuOpen = true;
  };

  button.sideMenuClosedMsg = function () {
    button._sideMenuOpen = false;
  };

  button.onPotBonusStartEvent = function () {
    button._potBonusActive = true;
  };

  button.onPotBonusStartEventDead = function () {
    button._potBonusActive = false;
  };

  return button;
};

buyBonusButton.initialise = function (json, object) {
  object.soundName = json.soundName || "";
  object.setupResources();
};

buyBonusButton.getFilesRequired = function () {
  return [];
};

resourceManager.registerObjectType(
  "buyBonusButton",
  buyBonusButton.create,
  buyBonusButton.initialise,
  buyBonusButton.getFilesRequired
);
